<template>
  <div class="five_section" :style="`background-color: ${bg}`">
    <h1>{{ practiceData.title }}</h1>
    <div class="scene_wrapper">
      <div class="item" v-for="item in practiceData.items" :key="item.id">
        <img :src="item.imgSrc" :alt="item.intro" />
        <div class="intro">
          <p>{{ item.intro }}</p>
        </div>
      </div>

      <!-- <div class="item">
        <img src="../../assets/home/changjin-2.webp" alt="changjin2" />
        <div class="intro">
          <p>北斗短报文自动水文监测站</p>
        </div>
      </div>

      <div class="item">
        <img src="../../assets/home/changjin-3.webp" alt="changjin3" />
        <div class="intro">
          <p>北斗短报文车载监控系统</p>
        </div>
      </div>

      <div class="item">
        <img src="../../assets/home/changjin-4.webp" alt="changjin4" />
        <div class="intro">
          <p>企业快速定制北斗APP</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bg: {
      type: String,
      default: '#ffffff',
    },
    practiceData: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.five_section {
  width: 100%;
  height: 611px;
  // background: #edf1fb;
  h1 {
    margin: 0;
    text-align: center;
    font-size: 28px;
    font-weight: 400;
    color: #0d0e24;
    padding: 66px 0px;
  }
  .scene_wrapper {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .item {
      width: 286px;
      height: 372px;
      position: relative;
      overflow: hidden;
      img {
        // width: 286px;
        // max-width: 100%;
        width: 100%;
        // height: 372px;
        position: absolute;
        left: 0;
        top: 0;
      }
      .intro {
        overflow: hidden;
        width: 100%;
        height: 44px;
        position: absolute;
        left: 0;
        bottom: 0;
        text-align: center;
        background-color: rgba(0, 0, 0, 0.5);
        p {
          font-size: 16px;
          font-weight: 400;
          color: #ffffff;
          line-height: 44px;
        }
      }
      &:hover {
        transform: scale(1.05);
        transition: transform 0.5s ease-in-out;
      }
    }
  }
}
</style>